@if (store.breadcrumbs(); as bc) {
  <div class="breadcrumbs-container">
    <div class="pl-4 separator">|</div>
    <div class="breadcrumb-item w-[60px] hidden @4xl:flex">
      <button
        [routerLink]="['/dashboard']"
        mat-button
      >
        <span class="icon-wrapper">
          <mat-icon class="material-icons-outlined">home</mat-icon>
        </span>
      </button>
    </div>
    <div class="separator">/</div>

    <div class="breadcrumb-item">
      <button
        (menuOpened)="store.loadBuildings()"
        [matMenuTriggerFor]="buildingMenu"
        mat-button
      >
        <span class="icon-wrapper">
          <i class="icon-building"></i>
        </span>
        <span class="breadcrumb-label">{{ bc.location.friendlyName }}</span>
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #buildingMenu="matMenu">
        @if (store.isLoading()) {
          <div class="spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
        @for (building of store.buildings(); track building.id) {
          <button
            [routerLink]="['/dashboard', building.id]"
            mat-menu-item
          >
            {{ building.friendlyName }}
          </button>
        }
      </mat-menu>
    </div>
    <div class="separator">/</div>

    <div class="breadcrumb-item hidden @4xl:flex">
      <button
        (menuOpened)="store.loadFloors()"
        [matMenuTriggerFor]="floorMenu"
        mat-button
      >
        <span class="icon-wrapper">
          <i class="icon-floor"></i>
        </span>
        <span class="breadcrumb-label">{{ bc.floor.friendlyName }}</span>
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #floorMenu="matMenu">
        @if (store.isLoading()) {
          <div class="spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
        @for (floor of store.floors(); track floor.id) {
          <button
            [routerLink]="['/dashboard', bc.location.id, floor.id]"
            mat-menu-item
          >
            {{ floor.friendlyName }}
          </button>
        }
      </mat-menu>
    </div>
    <span class="@4xl:hidden">...</span>
    <div class="separator">/</div>

    <div class="breadcrumb-item hidden @3xl:flex">
      <button
        (menuOpened)="store.loadRooms()"
        [matMenuTriggerFor]="roomMenu"
        mat-button
      >
        <span class="icon-wrapper">
          <i class="icon-room"></i>
        </span>
        <span class="breadcrumb-label">{{ bc.room.friendlyName }}</span>
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #roomMenu="matMenu">
        @if (store.isLoading()) {
          <div class="spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
        @for (room of store.rooms(); track room.id) {
          <button
            [routerLink]="['/dashboard', bc.location.id, bc.floor.id, room.id]"
            mat-menu-item
          >
            {{ room.friendlyName }}
          </button>
        }
      </mat-menu>
    </div>

    <div class="separator">/</div>

    <div class="breadcrumb-item breadcrumb-item-device">
      <button
        (menuOpened)="store.loadDevices()"
        [matMenuTriggerFor]="deviceMenu"
        mat-button
      >
        <span class="breadcrumb-label">
          @if (bc.parentDevice) {
            {{ bc.parentDevice.friendlyName }} >
          }
          {{ bc.device.friendlyName }}
        </span>
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #deviceMenu="matMenu">
        @if (store.isLoading()) {
          <div class="spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
        @for (device of store.devices(); track device.id) {
          <button
            [routerLink]="['/devices', bc.location.id, device.id]"
            mat-menu-item
          >
            {{ device.friendlyName }}
          </button>
        }
      </mat-menu>
    </div>
  </div>
}
